import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Grid } from '@mui/material';
import React from 'react';
import { getPresignedURLForGet } from 'wisestep-api';
import { WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

import NoCandidatesSVG from '../../../../../images/content/NoCandidates.svg';
interface NoPreviewDownloadProps {
  selectedFileUrl: string;
  selctedCvName: string;
}
const NoPreviewDownload: React.FC<NoPreviewDownloadProps> = ({
  selectedFileUrl,
  selctedCvName,
}) => {
  const handleDownload = async () => {
    if (selectedFileUrl) {
      try {
        const data = await getPresignedURLForGet({
          fileName: selectedFileUrl,
        });
        if (data && data.data.preSignedUrl) {
          const response = await fetch(data.data.preSignedUrl);
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = selctedCvName || selectedFileUrl.split('/').pop() || 'file';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    }
  };
  return (
    <Grid
      sx={{
        height: '550px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
      id="noMappingRightPane"
    >
      <img src={NoCandidatesSVG} alt="No Candidate ?" height={200} width={200} />
      <Grid mt={3}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>
          {'Preview not available for the selected file'}
        </WsTypography>
      </Grid>
      <Grid mt={3}>
        <WsButton
          variant="contained"
          startIcon={<FileDownloadOutlinedIcon />}
          onClick={handleDownload}
        >
          Download
        </WsButton>
      </Grid>
    </Grid>
  );
};
export default NoPreviewDownload;
